import { TouchableOpacity } from 'react-native';

import { Box, Text } from '@components/Restyle';
import Icon from '@components/shared/Icon/Icon';

interface FilterSheetHeaderProps {
  title: string;
  /** X closes the sheet on the main step; ChevronLeft returns from a sub-page. */
  icon: 'X' | 'ChevronLeft';
  onPress: () => void;
  testID: string;
  accessibilityLabel: string;
}

/**
 * Header shared by every filter sheet's main step and its sub-pages — matches
 * the "header" component in the Figma spec (node 206:76104 for the main
 * "Filter" sheet, 206:76420/206:76438 for sub-pages): a circular icon button on
 * the left, a centered title, and a hidden same-size spacer on the right so the
 * title stays visually centered.
 */
export const FilterSheetHeader: React.FC<FilterSheetHeaderProps> = ({
  title,
  icon,
  onPress,
  testID,
  accessibilityLabel,
}) => (
  <Box
    flexDirection='row'
    alignItems='center'
    paddingHorizontal='m'
    paddingBottom='xs'>
    <TouchableOpacity
      testID={testID}
      accessibilityLabel={accessibilityLabel}
      onPress={onPress}>
      <Box
        width={32}
        height={32}
        borderRadius='m'
        borderWidth={1}
        borderColor='grey02'
        alignItems='center'
        justifyContent='center'>
        <Icon name={icon} variant='s' color='textPrimary' />
      </Box>
    </TouchableOpacity>
    <Text
      flex={1}
      textAlign='center'
      variant='labelEmphasizedChatDetialTitle'
      color='textPrimary'>
      {title}
    </Text>
    {/* Spacer balancing the left button so the title stays centered. */}
    <Box width={32} />
  </Box>
);
